import { createLucideIcon } from 'lucide-react';

export const MarkerPin4 = createLucideIcon('MarkerPin4', [
    [
        'path',
        {
            d: 'M13 8C13 8.5523 12.5523 9 12 9C11.4477 9 11 8.5523 11 8C11 7.4477 11.4477 7 12 7C12.5523 7 13 7.4477 13 8Z',
            key: '1xkynn',
        },
    ],
    [
        'path',
        {
            d: 'M18 8C18 12.0637 13.5 14 12 17C10.5 14 6 12.0637 6 8C6 4.6863 8.6863 2 12 2C15.3137 2 18 4.6863 18 8Z',
            key: '1cudoq',
        },
    ],
    [
        'path',
        {
            d: 'M5 14.2864C3.1486 15.1031 2 16.2412 2 17.5C2 19.9853 6.4772 22 12 22C17.5228 22 22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864',
            key: '1va5y9',
        },
    ],
]);
